import { Theme } from '@mui/material/styles';

export const getSnackbarStyles = ({ backrs, typography }: Theme) => ({
  '& .MuiSnackbarContent-root': {
    backgroundColor: backrs.colors['Colors/Base/Black'],
    borderRadius: backrs.radius['radius-md'],
    color: backrs.colors['Colors/Base/White'],
  },
  '& .MuiSnackbarContent-action': {
    marginRight: backrs.spacing['spacing-none'],
  },

  '& .MuiSnackbarContent-message': {
    ...typography['text-sm-medium'],
  },
});
